import { Bacs } from './bacs';

export class BacsConditions {
  bacId: number;
  bac: Partial<Bacs>;
  groupes: BacsConditionsGroups[];
}

export class BacsConditionsGroups {
  groupGuid: string;
  conditions: BacsConditionsGroupsConditions[];
}

export class BacsConditionsGroupsConditions {
  id: number;
  bacId: number;
  element: string;
  field: string;
  operator: string;
  value: string;
  createdAppUserId: string;
  createdExternalUserId: string;
  createdDate: string;
  updatedExternalUserId: string;
  updatedAppUserId: string;
  updatedDate: string;
  dateField: string;
  dateOperator: string;
  dateDays: number;
}
